import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Card, Tag, message, Spin } from 'antd';
import { api } from '../../contexts/AuthContext';

const UserReview = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await api.get('/admin/users/pending');
      setUsers(response.data.users);
    } catch (error) {
      message.error('获取待审核用户失败');
      console.error('获取待审核用户失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleActivate = async (userId) => {
    try {
      await api.post(`/admin/users/${userId}/activate`);
      message.success('用户已激活');
      fetchUsers();
    } catch (error) {
      message.error('激活失败');
      console.error('激活失败:', error);
    }
  };

  const columns = [
    {
      title: '用户名',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: '昵称',
      dataIndex: 'nickname',
      key: 'nickname',
    },
    {
      title: '邮箱',
      dataIndex: 'email',
      key: 'email',
      ellipsis: true,
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      key: 'phone',
      render: (val) => val || '-',
    },
    {
      title: '角色',
      dataIndex: 'role',
      key: 'role',
      render: (val) => (
        <Tag color={val === 'publisher' ? 'blue' : 'green'}>
          {val === 'publisher' ? '发布者' : '创作者'}
        </Tag>
      ),
    },
    {
      title: '注册时间',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 160,
      render: (val) => val ? new Date(val).toLocaleString('zh-CN') : '-',
    },
    {
      title: '操作',
      key: 'action',
      width: 120,
      render: (_, record) => (
        <Button size="small" type="primary" onClick={() => handleActivate(record.id)}>
          激活账户
        </Button>
      ),
    },
  ];

  return (
    <div>
      <h2>用户审核</h2>
      <p style={{ color: '#666', fontSize: '14px' }}>审核通过后，发布者用户才能发布任务</p>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '50px 0' }}>
          <Spin size="large" />
        </div>
      ) : (
        <Card>
          <Table
            dataSource={users}
            columns={columns}
            rowKey="id"
            pagination={{ pageSize: 10 }}
            locale={{ emptyText: '暂无待审核用户' }}
          />
        </Card>
      )}
    </div>
  );
};

export default UserReview;